import React from "react";
import Seo from "../components/seo";
import { Link } from "gatsby";
import Carousel from "../components/layout/Carousel";
import useIsInViewport from "../hooks/useIsInViewport";

/* START: images import */
import biocultus from "../img/services/biocultus.svg";
import napraia from "../img/services/logo-na-praia.svg";
import mouse_app from "../img/services/mouse_app.svg";
import furnatura from "../img/services/furnatura-prague.svg";
import spell from "../img/services/spell.svg";
import kohinoor from "../img/services/kohinoor.svg";
import project_royal_mail from "../img/services/project_royal_mail.svg";
import project_mondelez from "../img/services/project_mondelez.svg";
import experience_react from "../img/services/react.svg";
import experience_angular from "../img/services/angular.svg";
import experience_laravel from "../img/services/laravel.svg";
import experience_gitlab from "../img/services/gitlab.svg";
import experience_electron from "../img/services/electron.svg";
import experience_gatsby from "../img/services/gatsby.svg";
import experience_trello from "../img/services/trello.svg";
import experience_android from "../img/services/android.svg";
import experience_ios from "../img/services/ios.svg";
import experience_nodejs from "../img/services/nodejs.svg";
import experience_slack from "../img/services/slack.svg";
import experience_mysql from "../img/services/mysql.svg";
import experience_atlassian from "../img/services/atlassian.svg";
import joalis_logo from "../img/services/logo-joalis.png";
import mpm from "../img/services/mpm.svg";
import smreflex from "../img/services/smreflex.svg";
import firebase from "../img/services/firebase.svg";
import aws from "../img/services/aws.svg";
import nextjs from "../img/services/nextjs.svg";
import swagger from "../img/services/swagger.svg";
import figma from "../img/services/figma-logo.svg";
import postman from "../img/services/postman.svg";
import docker from "../img/services/docker.svg";
import sketch from "../img/services/sketch.svg";

/* END: images import */

const carouselItems = [
    { src: nextjs, alt: "Nextjs" },
    { src: experience_react, alt: "React Native" },
    { src: experience_angular, alt: "Angular" },
    { src: experience_nodejs, alt: "NodeJS" },
    { src: experience_laravel, alt: "Laravel" },
    { src: figma, alt: "Figma" },
/*     { src: experience_gatsby, alt: "Gatsby" }, */
    // { src: experience_gulp, alt: "Gulp" },
    // { src: experience_cordova, alt: "Cordova" },
    { src: experience_ios, alt: "iOS" },
    /* { src: experience_atlassian, alt: "Atlassian" }, */
    { src: experience_android, alt: "Android" },
    { src: experience_electron, alt: "Electron" },
    { src: experience_gitlab, alt: "GitLab" },
    /* { src: experience_trello, alt: "Trello" }, */
    /* { src: experience_slack, alt: "Slack" }, */
    // { src: experience_docker, alt: "Docker" },
    { src: experience_mysql, alt: "MySQL" },
    // { src: jenkins, alt: "Jenkins" },
    { src: aws, alt: "AWS" },
    { src: firebase, alt: "Firebase" },
    { src: swagger, alt: "Swagger" },
    { src: postman, alt: "Postman" },
    { src: docker, alt: "Docker" },
    /* { src: sketch, alt: "Sketch" }, */
    // { src: aws, alt: "AWS" },
    // { src: protractor, alt: "Protractor" },
    // { src: mobx, alt: "Mob X" },
    //        {src:arduino, alt:"Arduino"},
    // { src: jasmine, alt: "Jasmine" },
    // { src: raspi, alt: "Raspberry Pi" }
];

const Intro = ({ indx, setObserverRef }) => (
    <article className="article" id="SSG" ref={setObserverRef} data-observer={indx}>
        <article className="text">
            <h2 className="line animate-1">Next.JS</h2>
            <p className="animate-2">
                <a href="https://nextjs.org/" target="_blank" rel="noopener noreferrer">Next.js</a> helps us create highly performant web applications and superfast websites. It is renowned for facilitating better user experiences and enabling rapid
                feature development. Its capabilities are leveraged by industry giants like{" "}
                <a href="https://www.netflix.com" target="_blank" rel="noopener noreferrer">
                    Netflix
                </a>
                ,{" "}
                <a href="https://www.nike.com" target="_blank" rel="noopener noreferrer">
                    Nike
                </a>{" "}
                or{" "}
                <a href="https://www.uber.com" target="_blank" rel="noopener noreferrer">
                    Uber
                </a>
                , as well as emerging start-ups.
            </p>
        </article>
        <article>
            <h3 className="animate-3">Example Next.js Projects</h3>
            <div className="examples animate-4">
                <div>
                    <img className="animate-5" src={mpm} style={{ margin: "28px", height: "78px" }} alt="DrMouse" />
                    <h4 className="line project animate-6">Online catalogue</h4>
                    <p className="animate-7">
                        Next.JS allowed us to strike the best balance between performance of static file generation and the hassle of building the whole site over and over again. Part
                        of the site is ready (as a static file) up front whilst the dynamic elements stay always up to date.
                    </p>
                    <a className="animate-8" href="https://www.mobilephonemuseum.com" target="_blank" rel="noopener noreferrer">
                        View the site
                    </a>
                </div>
                <div>
                    <img className="animate-5" src={joalis_logo} style={{ margin: "40px", maxWidth: "150px", marginTop: "10px" }} alt="Joalis" />
                    <h4 className="line project animate-6">A technological showcase</h4>
                    <p className="animate-7">
                        Fully fledged{" "}
                        <a href="https://www.shop8.cz/" target="_blank" rel="noopener noreferrer">
                            shop8
                        </a>{" "}
                        experience - Fine-tuned admin dashboard, powerful GraphQL API, S3 storage, robust deployment pipeline, SSG/SSR website, front shop &amp; mobile app.
                        Multiple languages, product variants, currencies, payment gateways, and more.
                    </p>
                    <a className="animate-8" href="https://www.joalis.cz/" target="_blank" rel="noopener noreferrer">
                        View the site
                    </a>
                </div>
            </div>
        </article>
    </article>
);

const Eshops = ({ indx, setObserverRef }) => (
    <article className="article" id="eshop" ref={setObserverRef} data-observer={indx}>
        <div className="text">
            <h2 className="line animate-1">E-commerce platform</h2>
            <p className="animate-2">
                We build e-commerce solutions on our own proven platform, designed for quick deployment and easy customization. It enables a fast start, stable operation, and tailoring at every level - from features and integrations to scaling as your business grows.
            </p>
        </div>
        <h3 className="animate-3">Example Projects</h3>
        <div className="examples animate-4">
            <div>
                <img className="animate-5" src={biocultus} style={{ margin: "85px", maxWidth: "300px" }} alt="Biocultus" />
                <h4 className="line project animate-6">Eco-friendly toilets for anywhere</h4>
                <p className="animate-7">
                    We developed a modern e-shop for Biocultus to showcase their world-class Finnish composting systems. Built on the custom <a href="https://shop8.cz/" target="_blank" rel="noopener noreferrer">Shop8</a> platform with a Next.js frontend, the site offers fast performance, supports multiple countries, languages, and currencies, and delivers a seamless international shopping experience.
                </p>
                <a className="animate-8" href="https://biocultus.com" target="_blank" rel="noopener noreferrer">
                    View the site
                </a>
            </div>
            <div>
                <img className="animate-5" src={furnatura} style={{ margin: "25px", width: "240px" }} alt="Furnatura" />
                <h4 className="line project animate-6">The key to healthy dog fur</h4>
                <p className="animate-7">
                    Another incarnation of our <a href="https://shop8.cz/" target="_blank" rel="noopener noreferrer">Shop8</a> e-commerce platform. This time a stylish e-shop for premium Czech brand Furnatura, specializing in natural cosmetics for dogs. Fast, multi-currency, multi-language, with a sleek design.
                </p>
                <a className="animate-8" href="https://www.furnatura.com/" target="_blank" rel="noopener noreferrer">
                    View the site
                </a>
            </div>
        </div>
    </article>
);

const CMSs = ({ indx, setObserverRef }) => (
    <article className="article" id="cms" ref={setObserverRef} data-observer={indx}>
        <div className="text">
            <h2 className="line animate-1">CMS solutions</h2>
            <p className="animate-2">
                Our modular, in-house CMS gives clients the freedom to compose pages from content blocks while preserving a clean, consistent design. It is ideal for projects that require flexible content management without losing control over structure and visual identity.
            </p>
        </div>
        <h3 className="animate-3">Example Projects</h3>
        <div className="examples animate-4">
            <div>
                <img className="animate-5" src={napraia} style={{ margin: "32px", width: "240px" }} alt="Na Praia" />
                <h4 className="line project animate-6">Luxury hotel</h4>
                <p className="animate-7">
                    Our long-term client wanted the freedom to build pages from modular content types while maintaining a clean, consistent design. Our custom CMS proved to be a perfect fit for this approach.
                </p>
                <a className="animate-8" href="https://www.napraia.com/" target="_blank" rel="noopener noreferrer">
                    View the site
                </a>
            </div>
            <div>
                <img className="animate-5" src={spell} style={{ margin: "25px", maxWidth: "150px" }} alt="Biocultus" />
                <h4 className="line project animate-6">Spelldesk - Point of sale</h4>
                <p className="animate-7">
                    We delivered a custom-built solution for a hair salon that covers point-of-sale operations, sales of services and bistro items, and provides clear performance reports for dialy operations.
                </p>
                <a className="animate-8" href="mailto:info@code8.cz">
                    Enquire
                </a>
            </div>
        </div>
    </article>
);

const MobileApps = ({ indx, setObserverRef }) => (
    <article className="article" id="mobileApps" ref={setObserverRef} data-observer={indx}>
        <div className="text">
            <h2 className="line animate-1">Mobile apps</h2>
            <p className="animate-2">
                Sharing majority of code between Android and iOS saves a lot of resources when building and maintaining your project. We rely on hybrid technologies like React
                Native to get more bang for your buck.
            </p>
        </div>
        <h3 className="animate-3">Example Mobile Apps Projects</h3>
        <div className="examples animate-4">
            <div>
                <img className="animate-5" src={mouse_app} style={{ margin: "40px", width: "85px" }} alt="Dr Mouse App" />
                <h4 className="line project animate-6">Finding vets in Czechia</h4>
                <p className="animate-7">
                    Dr. Mouse is a mobile app for Android and iOS. It&nbsp;maps veterinaries in Czechia and helps you find the right vet for your pet anywhere. Even offline. Handy
                    in case of emergency, don't you think?{" "}
                </p>
                <a className="animate-8" href="https://www.drmouse.cz/aplikace" target="_blank" rel="noopener noreferrer">
                    View the site
                </a>
            </div>
            <div>
                <img className="animate-5" src={smreflex} style={{ margin: "45px", height: "70px" }} alt="Debrett’s wedding planner" />
                <h4 className="line project animate-6">SM Reflex</h4>
                <p className="animate-7">
                    Zentiva's program is aimed at patients with multiple sclerosis. The purpose of the app is to help patients to manage their disease and provide educational
                    resources which could help to improve their quality of life.
                </p>
                <a className="animate-8" href="https://smreflex.sk" target="_blank" rel="noopener noreferrer">
                    View the site
                </a>
            </div>
        </div>
    </article>
);

const BeSpoke = ({ indx, setObserverRef }) => (
    <article className="article" id="bespoke" ref={setObserverRef} data-observer={indx}>
        <div className="text">
            <h2 className="line animate-1">APIs, Backend Systems &amp; DevOps</h2>
            <p className="animate-2">
                We provide custom Node.js and PHP development, focusing on SQL-based databases, RESTful APIs, and specialized tasks such as system audits, performance optimization and content migration. We also bring strong expertise in DevOps, CI/CD, and cost-efficient automated testing.
            </p>
        </div>
        <h3 className="animate-3">Example Bespoke Projects</h3>
        <div className="examples animate-4">
            <div>
                <img className="animate-5" src={project_royal_mail} style={{ margin: "40px", width: "150px" }} alt="Royal Mail PAF" />
                <h4 className="line project animate-6">Royal Mail PAF</h4>
                <p className="animate-7">
                    With our partners at{" "}
                    <a href="http://www.dataadvance.co.uk" target="_blank" rel="noopener noreferrer">
                        Data advance
                    </a>{" "}
                    we've been involved in various projects, including Royal Mail's PAF Licensing Centre.
                </p>
                <a className="animate-8" href="http://www.poweredbypaf.com/licensing-centre/" target="_blank" rel="noopener noreferrer">
                    View the site
                </a>
            </div>
            <div>
                <img className="animate-5" src={project_mondelez} style={{ margin: "65px", maxWidth: "300px" }} alt="Mondelez" />
                <h4 className="line project animate-6">Interactive Map</h4>
                <p className="animate-7">A LAMP application—a tool for detailed overview of company brands with a social (networks) presence in the EU.</p>
                <a className="animate-8" href="mailto:hello@code8.cz">
                    Request a code snippet
                </a>
            </div>
{/*             <div>
                <img className="animate-5" src={project_mondelez} style={{ margin: "65px", maxWidth: "300px" }} alt="Mondelez" />
                <h4 className="line project animate-6">Interactive Map</h4>
                <p className="animate-7">A LAMP application - a tool for detailed overview of company brands with a social (networks) presence in the EU.</p>
                <a className="animate-8" href="mailto:hello@code8.cz">
                    Request a code snippet
                </a>
            </div> */}
        </div>
    </article>
);

const Experience = ({ indx, setObserverRef }) => (
    <article className="article" id="experience" ref={setObserverRef} data-observer={indx}>
        <div className="text">
            <h2 className="line animate-1">Platform experience</h2>
            <p className="animate-2">We have extensive experience with the following platforms. </p>
        </div>
        <div id="experienced" className="animate-3">
            <Carousel items={carouselItems} />
        </div>
        <div className="clear"></div>
        <div className="text animate-4" style={{ position: "relative", zIndex: 500 }}>
            <br />
            <p>
                <Link to="/projects/">See what we've built</Link>
            </p>
        </div>
    </article>
);

const sections = [Intro, Eshops, CMSs, MobileApps, BeSpoke, Experience];

const Services = () => {
    const { setRef } = useIsInViewport();
    return (
        <>
            <Seo title="Services" />
            <div>
                {sections.map((Component, index) => (
                    <Component key={index} indx={index} setObserverRef={setRef} />
                ))}
            </div>
            <div className="clear"></div>
        </>
    );
};
export default Services;
